<template>
  <div>
    <div
      class="main-intro-wrapper"
      v-for="(item, index) in accIntroductions"
      :key="index"
      @click="handleOpenDialog(item)"
    >
      <div class="main-intro__content">
        <img :src="item.bgImage" alt="img" />
        <div class="main-intro-title">{{ item.title }}</div>
      </div>
    </div>
    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div class="intro-dialog__content center">
        <div v-for="(item, index) in introForm.content" :key="index">
          <p v-if="typeof item === 'string'">{{ item }}</p>
          <div v-else-if="Array.isArray(item)" class="img__content">
            <div v-for="(i, idx) in item" :key="idx" class="img">
              <img :src="i.image" alt="" /> <span>{{ i.text }}</span>
            </div>
          </div>
          <div v-else class="img__content">
            <div class="img sm">
              <img v-if="item.image" :src="item.image" alt="" />
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="introDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { accIntroductions } from '@src/constant/home'

@Component
export default class AccClass extends Vue {
  accIntroductions = accIntroductions
  introForm = {}
  introDialog = false

  handleOpenDialog(item) {
    this.introForm = { ...item }
    this.introDialog = true
  }
}
</script>

<style lang="scss" scoped>
.main-intro__content {
  position: relative;
  cursor: pointer;
  .main-intro-title {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 7%;
    color: #25878e;
    font-size: 1.6vw;
    @media screen and (min-width: 1920px) {
      font-size: 30px;
    }
  }
}

.intro-dialog .intro-dialog__content {
  text-indent: 2em;
  line-height: 1.5em;
  font-size: 16px;
  .img__content {
    display: flex;
    justify-content: center;
    text-indent: 0;
    text-align: center;
    .img {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 1vw;
      img {
        border: 1px dashed #666;
        width: 100%;
      }
      &.sm {
        line-height: 2;
        font-weight: 600;
        img {
          max-width: 400px;
        }
      }
    }
  }
}
</style>
